import { PaletteMode } from '@mui/material';
import { ChronosphereColorPalette, red } from '../colors';
import { GetThemeOptions } from '../../theme';
import { unityDarkTokens, unityLightTokens } from '@/theme/unityTokens';

export const errorColor = (mode: PaletteMode, opts: GetThemeOptions): ChronosphereColorPalette => {
  if (opts.panwRebrandStubYear) {
    return mode === 'light'
      ? {
          main: unityLightTokens['--data-informative-negative'],
          highContrast: unityLightTokens['--data-informative-negative-high-contrast'],
          lowContrast: unityLightTokens['--data-informative-negative-low-contrast'],
        }
      : {
          main: unityDarkTokens['--data-informative-negative'],
          highContrast: unityDarkTokens['--data-informative-negative-high-contrast'],
          lowContrast: unityDarkTokens['--data-informative-negative-low-contrast'],
        };
  }

  return mode === 'light'
    ? {
        main: red[600],
        highContrast: red[700],
        lowContrast: red[100],
      }
    : {
        main: red[500],
        highContrast: red[100],
        lowContrast: red[800],
      };
};
